<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
$(".faq-head").click(function(){
  //$(".faq-head").removeClass("transform");  
  $(this).toggleClass('transform');
  //$('.faq-body').hide();
  $(this).next('.faq-body').toggle();
});